module.exports = __webpack_public_path__ + "static/media/calendar-edit.dc57fe00.svg";